import { createNetworkStatusNotifier } from "react-apollo-network-status";

const {link, useApolloNetworkStatus} = createNetworkStatusNotifier();

export const networkStatusLink = link;

export const useNetworkStatus = useApolloNetworkStatus;

